<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    export default {
        props: {
            label: String,
            value: [String, Number],
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: 0,
            }
        },
        methods: {
            change(v){
                this.$emit('change', v);
            }
        },
        computed: {
            ...mapState('dictionary/paymentDirection', {
                list: state => state.list
            }),

        },
        watch: {
            value(v){
                this.val= v;
            },
            val(v){
                this.$emit('input', v);
            },
        },
        components: {},
        mounted() {
            this.val = this.value;

        },
        destroyed() {

        },
    }
</script>
<template>
    <div class="input-payment-direction">
        <div class="el-input-group el-input--mini" :class="{'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <el-select v-model="val" :disabled="disabled" :clearable="clearable" @change="change">
                <el-option v-for="item in list" :value="item.value" :key="item.value" :label="item.label"></el-option>
            </el-select>
        </div>
    </div>
</template>
<style lang="scss">
    .input-payment-direction {
        .el-select{
            width: 100%;
        }
    }
</style>
